export default "__VITE_ASSET__C5eMSoso__"